import { render, staticRenderFns } from "./AddEpisodeDetailsTab.vue?vue&type=template&id=82236e40&"
import script from "./AddEpisodeDetailsTab.vue?vue&type=script&lang=js&"
export * from "./AddEpisodeDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports